import React from 'react';
import { Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { notEmptyRule } from './validationUtils';
import ImageDisplayField from '../ImageDisplayField';


const TouristInformationSection = ({ 
  sectionKey, 
  sectionData, 
  uploadingImage, 
  uploadProps, 
  handleImageUploadForSection,
  currentLanguage,
  form
}) => {
  const { t } = useTranslation();
  
  // Create dynamic field names based on current language
  const langKey = currentLanguage.toLowerCase();
  const getFieldName = (field) => ['content', langKey, sectionKey, field];

  return (
    <>
      {/* Regular section fields */}
      {sectionData.title !== undefined && (
        <Form.Item
          name={getFieldName('title')}
          label={t('Titolo')}
          rules={[notEmptyRule(t, 'Il campo non può essere vuoto')]}
        >
          <Input placeholder={t('Inserisci il titolo')} />
        </Form.Item>
      )}

      {sectionData.button !== undefined && (
        <Form.Item
          name={getFieldName('button')}
          label={t('Testo del pulsante')}
          rules={[notEmptyRule(t, 'Il campo non può essere vuoto')]}
        >
          <Input placeholder={t('Inserisci il testo del pulsante')} />
        </Form.Item>
      )}

      {sectionData.image !== undefined && (
        <Form.Item
          name={getFieldName('image')}
          label={t('Immagine')}
          rules={[notEmptyRule(t, 'Il campo non può essere vuoto')]}
        >
          <ImageDisplayField
            name={getFieldName('image')}
            label={t('Immagine')}
            uploadingImage={uploadingImage}
            uploadProps={uploadProps}
            onUpload={(file) => handleImageUploadForSection(file, sectionKey)}
            onRemove={() => {
              const currentValues = form.getFieldsValue();
              const fieldPath = getFieldName('image');
              let current = currentValues;
              for (let i = 0; i < fieldPath.length - 1; i++) {
                if (!current[fieldPath[i]]) {
                  current[fieldPath[i]] = {};
                }
                current = current[fieldPath[i]];
              }
              current[fieldPath[fieldPath.length - 1]] = '';
              form.setFieldsValue(currentValues);
            }}
          />
        </Form.Item>
      )}
    </>
  );
};

export default TouristInformationSection; 